export const PHONE_ENTRY_STRINGS = {
    PageTitle: 'Zocdoc | Booking | Phone',
    EnterYourPhoneNumber: 'Please enter your phone number',
    InCaseDoctor: 'In case the doctor needs to contact you',
    SomethingWentWrong: 'Oops! Something went wrong. Please try again later.',
};

export const SOMETHING_WENT_WRONG_ERROR = 'SOMETHING_WENT_WRONG';
